import React, { PropTypes } from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

import routes from '../routes'

const Root = ({ store, history }) => (
  <Provider store={store}>
    <div>
      <ConnectedRouter history={history}>
        <div>
          {routes}
        </div>
      </ConnectedRouter>
    </div>
  </Provider>
);


Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.prod.js